import { HttpClient } from '@angular/common/http';
import { contexteDePortee, sansMessageErreur } from '@shared/interceptors/contexte-http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { EtablissementDTO, PappersDTO } from '@logaia_users/logaia-dto';
import { Observable } from 'rxjs';

/**
 * Appels au back : API Siret, contrôleur Siret (service repris de l'ancien front).
 */
@Injectable({
  providedIn: 'root',
})
export class SiretService {
  private readonly baseUrl = `${environment.apiUrl.siret}Siret/`;
  private readonly http: HttpClient = inject(HttpClient);
  private readonly SIRET_KEY = 'siret_token';

  getTokenFromLocal(): string | null {
    return localStorage.getItem(this.SIRET_KEY);
  }

  setTokenLocal(token: string): void {
    localStorage.setItem(this.SIRET_KEY, token);
  }

  searchEtablissementFromSiret(siret: string, skipError = false): Observable<EtablissementDTO> {
    return this.http.get<EtablissementDTO>(`${this.baseUrl}${siret}`, {
      context: skipError ? sansMessageErreur() : undefined,
    });
  }

  searchEtablissementFromSiren(siren: string, skipError = false): Observable<EtablissementDTO[]> {
    return this.http.get<EtablissementDTO[]>(`${this.baseUrl}siren/${siren}`, {
      context: skipError ? sansMessageErreur() : undefined,
    });
  }

  /** Représentants et bénéficiaires effectifs d'une entreprise par son Siren (Outils › Appel Pappers, contrôleur Pappers). */
  pappersSiren(siren: string): Observable<PappersDTO> {
    return this.http.get<PappersDTO>(`${environment.apiUrl.siret}Pappers/siren/${encodeURIComponent(siren)}`, {
      context: contexteDePortee('cabinet'),
    });
  }

  /** Idem par le Siret d'un établissement. */
  pappersSiret(siret: string): Observable<PappersDTO> {
    return this.http.get<PappersDTO>(`${environment.apiUrl.siret}Pappers/siret/${encodeURIComponent(siret)}`, {
      context: contexteDePortee('cabinet'),
    });
  }
}
